import React from "react";

import TfgPreviewChanges from "./TfgPreviewChanges";

import "../../../css/Views/TfgPreviewItem.css";

const formatDate = (value) => {
  if (!value) {
    return "—";
  }

  return new Date(
    value
  ).toLocaleDateString("pl-PL");
};

const formatDateTime = (
  value
) => {
  if (!value) {
    return "—";
  }

  return new Date(
    value
  ).toLocaleString("pl-PL");
};

const formatMoney = (
  amount,
  currency = "PLN"
) => {
  if (
    amount === null ||
    amount === undefined
  ) {
    return "—";
  }

  return new Intl.NumberFormat(
    "pl-PL",
    {
      style: "currency",
      currency,
    }
  ).format(amount);
};

const getTravellersLabel = (
  count
) => {
  if (count === 1) {
    return "1 podróżny";
  }

  return `${count} podróżnych`;
};

const TfgPreviewItem = ({
  item,
}) => {
  const snapshot =
    item.snapshot ?? {};

  return (
    <article className="tfg-preview-details-card">
      <div className="tfg-preview-details-header">
        <div>
          <div className="tfg-preview-details-label">
            Numer umowy
          </div>

          <div className="tfg-preview-contract-number">
            {item.contractNumber}
          </div>
        </div>

        {item.cancellationDate && (
          <span className="tfg-preview-badge tfg-preview-badge--danger">
            Rozwiązana
          </span>
        )}
      </div>

      <div className="tfg-preview-item-content">
        <section className="tfg-preview-section">
          <div className="tfg-preview-details-grid">
            <PreviewValue
              label="Data zawarcia"
              value={formatDate(
                snapshot.contractDate
              )}
            />

            <PreviewValue
              label="Termin realizacji"
              value={`${formatDate(
                snapshot.realizationDateFrom
              )} – ${formatDate(
                snapshot.realizationDateTo
              )}`}
            />

            <PreviewValue
              label="Liczba podróżnych"
              value={
                snapshot.travellersCount ??
                "—"
              }
            />

            <PreviewValue
              label="Cena całkowita"
              value={formatMoney(
                snapshot.totalPrice,
                snapshot.currency
              )}
            />

            <PreviewValue
              label="Miejsce docelowe"
              value={
                snapshot.destinationCity ||
                "—"
              }
            />

            <PreviewValue
              label="Kod kraju"
              value={
                snapshot.countryCode ||
                "—"
              }
            />

            <PreviewValue
              label="Zakres terytorialny"
              value={
                snapshot.territorialScope ||
                "—"
              }
            />

            <PreviewValue
              label="Transport"
              value={
                snapshot.transportType ||
                "—"
              }
            />

            <PreviewValue
              label="Sposób płatności"
              value={
                snapshot.paymentMethod ||
                "—"
              }
            />

            {item.cancellationDate && (
              <PreviewValue
                label="Data rozwiązania"
                value={formatDate(
                  item.cancellationDate
                )}
              />
            )}

            <PreviewValue
              label="Wykrycie zmiany"
              value={formatDateTime(
                snapshot.changeDetectedAt
              )}
            />
          </div>
        </section>

        <div className="tfg-preview-financial-grid">
          <PaymentsSection
            title="Wpłaty"
            items={snapshot.payments}
          />

          <PaymentsSection
            title="Zwroty"
            items={snapshot.refunds}
          />
        </div>

        <TfgPreviewChanges
          changes={item.changes}
        />
      </div>
    </article>
  );
};

const PreviewValue = ({
  label,
  value,
}) => (
  <div className="tfg-preview-value">
    <span className="tfg-preview-value-label">
      {label}
    </span>

    <strong>{value}</strong>
  </div>
);

const PaymentsSection = ({
  title,
  items,
}) => (
  <section className="tfg-preview-section tfg-preview-financial-section">
    <h3 className="tfg-preview-section-title">
      {title}
    </h3>

    {!items?.length ? (
      <div className="tfg-preview-empty-value">
        Brak
      </div>
    ) : (
      <div className="tfg-payment-list">
        {items.map(
          (payment, index) => (
            <div
              key={`${payment.date}-${payment.amount}-${index}`}
              className="tfg-payment-row"
            >
              <span>
                {formatDate(
                  payment.date
                )}
              </span>

              <strong>
                {formatMoney(
                  payment.amount,
                  payment.currency
                )}
              </strong>
            </div>
          )
        )}
      </div>
    )}
  </section>
);

export default TfgPreviewItem;